import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/pt-br'
import './element-variables.scss'
import 'element-ui/lib/theme-chalk/display.css'

Vue.use(ElementUI, { size: 'small', locale })
